import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';
import BasicToggle from '../../../../../../shared/components/formComponents/groups/BasicToggle';
import BasicTextArea from '../../../../../../shared/components/formComponents/groups/BasicTextArea';
import { RuntimeContext } from '../../../../../../../common/RuntimeContext';

const CompanyTeamAbout = (props) => {
    const config = useContext(RuntimeContext);

    const normalizeTeamPermalink = (value) => {
        let formattedValue = '';
        if (value) {
            formattedValue = value.toLocaleLowerCase();
            if (formattedValue[0] === '/') formattedValue = formattedValue.slice(1);
        }
        return formattedValue;
    };

    return (
        <>
            <div className={'row team-info-fields-container'}>
                <Field
                    name={'name'}
                    label={'Team Name'}
                    placeholder={'My Team'}
                    className={'row company-form-field'}
                    component={BasicText}
                    enableReinitialize={true}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    description={'This is the team name that employees will see at the top of their Teams page.'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                {/* <Field
                    name={'permalink'}
                    label={'Team Permalink'}
                    placeholder={''}
                    className={'row company-form-field'}
                    component={BasicText}
                    enableReinitialize={true}
                    normalize={normalizeTeamPermalink}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    description={`Slug used in the URL to invite users to your team. [${config.app.ui.urlBase}../companyName/teamPermalink]`}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                /> */}
                <Field
                    name={'isActive'}
                    className={'row company-form-field'}
                    label={'Active'}
                    component={BasicToggle}
                    inputClassName={'col-12 col-sm-6'}
                    description={
                        'Make the team active when you are ready for employees to see this team on their Teams page. You can still save your changes even if the team is not active.'
                    }
                    styleProps={{ horizontal: true }}
                    id={'company-team-about-is-active-toggle'}
                />
                {
                    // <Field
                    //     placeholder={'Select...'}
                    //     className={'row company-form-field'}
                    //     inputClassName={'col-12 col-sm-5 no-padding'}
                    //     styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    //     label={'Team Lead Label'}
                    //     name={`teamLeadLabel`}
                    //     options={[
                    //         { label: 'Team Lead', value: 'TEAM_LEAD' },
                    //         { label: 'Manager', value: 'MANAGER' },
                    //         { label: 'Facilitator', value: 'FACILITATOR' },
                    //         { label: 'Trainer', value: 'TRAINER' },
                    //         { label: 'Coach', value: 'COACH' },
                    //     ]}
                    //     description={''}
                    //     component={BasicSelect}
                    // />
                }
                <Field
                    name={'description'}
                    label={'Description'}
                    placeholder={'Give a description of the team here.'}
                    className={'row company-form-field'}
                    component={BasicTextArea}
                    rows={7}
                    maxLength={'300'}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    description={
                        "This description of the team will be displayed on the home page in the team row and on the team's main page at the top. Max 300 characters."
                    }
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
            </div>
        </>
    );
};

CompanyTeamAbout.propTypes = {};

export default CompanyTeamAbout;
